import { render } from "./AuthEmployeeLeaveDetails.vue?vue&type=template&id=54e40a8c&scoped=true"
import script from "./AuthEmployeeLeaveDetails.vue?vue&type=script&lang=js"
export * from "./AuthEmployeeLeaveDetails.vue?vue&type=script&lang=js"

import "./AuthEmployeeLeaveDetails.vue?vue&type=style&index=0&id=54e40a8c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54e40a8c"]])

export default __exports__